import type {AnnotationTool} from './protocol';

export type ToolbarTool =
    | 'lock'
    | 'pan'
    | 'rectangle'
    | 'diamond'
    | 'circle'
    | 'arrow'
    | 'pencil'
    | 'highlighter'
    | 'text'
    | 'eraser';

export type EraserMode = 'pixel' | 'element' | 'clear';

export const ERASER_MODE_ORDER: readonly EraserMode[] = ['pixel', 'element', 'clear'];

export function getWireTool(t: ToolbarTool): AnnotationTool | null {
    switch (t) {
        case 'pencil':
            return 'pencil';
        case 'highlighter':
            return 'highlighter';
        case 'eraser':
            return 'eraser';
        default:
            return null;
    }
}

export function getWireToolForSession(t: ToolbarTool, eraserMode: EraserMode): AnnotationTool | null {
    if (t === 'eraser' && eraserMode !== 'pixel') return null;
    return getWireTool(t);
}

export function shapePreviewKind(
    t: ToolbarTool
): 'rectangle' | 'circle' | 'line' | 'diamond' | null {
    switch (t) {
        case 'rectangle':
            return 'rectangle';
        case 'diamond':
            return 'diamond';
        case 'circle':
            return 'circle';
        case 'arrow':
            return 'line';
        default:
            return null;
    }
}
